import Marionette from 'backbone.marionette';
import memberVotesCompositviewTmpl from '../templates/member_votes_compositeview.tpl';
import MemberVotesItemview from './member_votes_itemview';
export default Marionette.CompositeView.extend({
  template: memberVotesCompositviewTmpl,
  childView: MemberVotesItemview,
  tagName: "table",
  className: "table table-hover table-sm",
  childViewContainer: "tbody",
  id: "vote-list"

  /*
  onShow: function() {
    $("#vote-list").dataTable({
      bSort: false,
      pagingType: 'simple',
      responsive: false,
      //lengthChange: false,
      //bFilter: false,
     // "autoWidth": true,
    });
  }
  */
});